import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { RoundRepository } from "../round.repository";
import { IRoundGetStateData } from "../interfaces";
import { filter, Observable } from "rxjs";

@Injectable()
export class GetRoundInitialStateUseCase implements IUseCase<void, Observable<IRoundGetStateData>> {
    constructor(private roundRepository: RoundRepository) {
    }

    execute(): Observable<IRoundGetStateData> {
        return this.roundRepository.getCurrentRoundState().pipe(filter(Boolean));
    }
}
